/* global CONFIG */
import moment from 'moment'
import services from '../services'
import ft from '../featureToggle'

import ApiDispatchDrivers from './drivers'

export default {
  getReservations (VueApp, callback, noFetching) {
    let self = this
    let token = VueApp.$store.state.session.sessionToken
    let selectedFilter = VueApp.$store.state.reservation.selectedFilter
    let filter = null
    if (selectedFilter > -1 && selectedFilter !== 'custom') {
      filter = VueApp.$store.state.reservation.reservationFilters[selectedFilter]
    }
    let search = VueApp.$store.state.reservation.reservationSearch

    if (filter === null && search === '' && selectedFilter !== 'custom') {
      VueApp.$store.commit('dispatch/setNoDataFound', false)
      VueApp.$store.commit('dispatch/setRsvpInTable', [])
      return
    }

    let currentPage = VueApp.$store.state.dispatch.rsvpPaging.currentPage
    let request = {
      token: token,
      package: true,
      order: VueApp.$store.state.dispatch.rsvpSort.order,
      orderAsc: VueApp.$store.state.dispatch.rsvpSort.asc ? 1 : 0,
      search: VueApp.$store.state.reservation.reservationSearch,
      pageNum: currentPage,
      pageSize: VueApp.$store.state.dispatch.rsvpPaging.pageSize
    }

    if (filter !== null) {
      request['category'] = 'charged'
      request['filter'] = VueApp.$store.state.reservation.reservationFilters[selectedFilter]
    }

    if (selectedFilter === 'custom') {
      request['category'] = 'charged'
      request['filter'] = {
        ada: null,
        afterPickupMins: null,
        beforePickupMins: null,
        bidSource: null,
        defaultGeofenceId: null,
        defaultPickupAddress: null,
        defaultPickupType: null,
        geofenceIds: null,
        id: null,
        name: null,
        packageStatus: null,
        rsvpStatus: [],
        stagingLotIds: null,
        tripDirection: null
      }

      let rsvp = VueApp.$store.state.reservation
      let filterDate = rsvp.date
      if (filterDate.from && filterDate.to) {
        request['filter'].since = moment(filterDate.from, 'MM/DD/YYYY hh:mmA').format('YYYY-MM-DD HH:mm:ss')
        request['filter'].until = moment(filterDate.to, 'MM/DD/YYYY hh:mmA').format('YYYY-MM-DD HH:mm:ss')
      }
      request['filter'].serviceTypes = []
      if (!CONFIG.useOldQuatation) {
        request['filter'].serviceTypes = VueApp.$store.state.dispatch.filter.services
      } else {
        for (let service in rsvp.service) {
          let storeService = ''
          switch (service) {
            case 'shared':
              storeService = 'Shared'
              break
            case 'opoli':
              storeService = 'Opoli'
              break
            case 'black':
              storeService = 'Black'
              break
            case 'suv':
              storeService = 'SUV'
              break
            case 'shuttle':
              storeService = 'Private Shuttle'
              break
          }
          if (rsvp.service[service]) {
            request['filter'].serviceTypes.push(VueApp.$store.state.settings.serviceData[storeService].id)
          }
        }
      }

      for (let status in rsvp.status) {
        if (rsvp.status[status]) {
          request['filter'].rsvpStatus.push(status)
        }
      }
    }

    if (!noFetching) {
      VueApp.$store.commit('dispatch/setFetching', true)
    }
    VueApp.$sdk.post('/admin/rsvp/dispatch', request, r => {
      VueApp.$store.commit('dispatch/setFetching', false)
      if (r.error) {
        // TODO: process error
        console.log(r)
        if (callback) {
          callback(r)
        }
        return
      }

      let results = []
      for (let i = 0; i < r.list.length; i++) {
        let item = r.list[i]
        if (item.type === 'rsvp') {
          results.push(self.formatRsvp(VueApp, r.list[i].data))
          if (currentPage > 1) {
            VueApp.$store.commit('dispatch/pushRsvpInTable', self.formatRsvp(VueApp, r.list[i].data))
          }
          continue
        }
        if (item.type === 'package') {
          results.push(self.formatPackage(VueApp, r.list[i].data))
          if (currentPage > 1) {
            VueApp.$store.commit('dispatch/pushRsvpInTable', self.formatPackage(VueApp, r.list[i].data))
          }
          continue
        }
      }

      VueApp.$store.commit('dispatch/setNoDataFound', results.length <= 0)
      if (currentPage === 1) {
        VueApp.$store.commit('dispatch/setRsvpInTable', results)
      }
      VueApp.$store.commit('dispatch/setRsvpCurrentPage', parseInt(r.paging.pageNum))
      VueApp.$store.commit('dispatch/setRsvpTotalPages', parseInt(r.paging.totalItems))
      VueApp.$store.commit('dispatch/setDispatchTotal', r.paging.totalItems)
      if (callback) {
        callback(r)
      }
    })
  },
  initDispatchReservations (VueApp) {
    let self = this
    VueApp.$sdk.get('/admin/filters', {
      order: 'filterName',
      token: VueApp.$store.state.session.sessionToken
    }, r => {
      if (r.error) {
        console.log(r)
        return
      }
      VueApp.$store.commit('reservation/setReservationFilters', r.list)

      // Lost last selected filter
      let selectedFilterId = parseInt(VueApp.$plugins.storage.get('ADMIN_DISPATCH_FILTER'))
      if (isNaN(selectedFilterId)) {
        return
      }
      let selectedFilter = -1
      for (let i = 0; i < r.list.length; i++) {
        let filter = r.list[i]

        if (filter.id === selectedFilterId) {
          selectedFilter = i
          break
        }
      }
      if (selectedFilter >= 0) {
        VueApp.$store.commit('reservation/setSelectedFilter', selectedFilter)
        self.getReservations(VueApp)
        self.getLastSync(VueApp)
        ApiDispatchDrivers.getStagingDrivers(VueApp)
      }
    })
  },
  getLastSync (VueApp) {
    VueApp.$sdk.get('/admin/rsvp/dispatch/sync', {
      token: VueApp.$store.state.session.sessionToken
    }, r => {
      if (r.error) {
        console.log(r)
        return
      }
      VueApp.$store.commit('dispatch/setLastSync', moment(r.time, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'))
    })
  },
  updateReservationTable (VueApp, rsvpId) {
    let self = this
    VueApp.$store.commit('dispatch/loadNewBookingNotification')
    VueApp.$sdk.get('/admin/rsvp/' + rsvpId, {
      token: VueApp.$store.state.session.sessionToken
    }, r => {
      VueApp.$store.commit('dispatch/hideNotificationNewBooking')
      if (r.error) {
        return
      }

      let rsvp = null
      if (r.package) {
        rsvp = self.formatPackage(VueApp, r)
      } else {
        rsvp = self.formatRsvp(VueApp, r)
      }
      VueApp.$store.commit('dispatch/removeRsvpInTable', rsvp)
      VueApp.$store.commit('dispatch/addRsvpInTable', rsvp)
    })
  },
  updateItemInTable (VueApp, rsvp) {
    let self = this

    let url = '/admin/rsvp/'
    if (rsvp.isPackage) {
      url = '/admin/package/'
    }
    VueApp.$sdk.get(url + rsvp.id, {
      token: VueApp.$store.state.session.sessionToken
    }, r => {
      if (r.error) {
        console.log(r)
        return
      }

      let result = null
      if (r.package) {
        result = self.formatPackage(VueApp, r)
      } else {
        result = self.formatRsvp(VueApp, r)
      }

      // update rsvp in map
      let rsvpInMap = VueApp.$store.state.dispatch.rsvpInMap
      if (rsvpInMap.id !== null) {
        if (rsvpInMap.id === result.id &&
            rsvpInMap.isPackage === result.isPackage) {
          VueApp.$store.commit('dispatch/setRsvpInMap', result)
        }
      }
      let token = VueApp.$store.state.session.sessionToken
      let selectedFilter = VueApp.$store.state.reservation.selectedFilter
      let filter = null
      if (selectedFilter > -1) {
        filter = VueApp.$store.state.reservation.reservationFilters[selectedFilter]
      }
      let search = VueApp.$store.state.reservation.reservationSearch

      if (filter === null && search === '') {
        VueApp.$store.commit('dispatch/addRsvpInTable', result)
        return
      }

      let request = {
        token: token,
        package: true,
        search: VueApp.$store.state.reservation.reservationSearch,
        pageNum: VueApp.$store.state.dispatch.rsvpPaging.currentPage,
        pageSize: VueApp.$store.state.dispatch.rsvpPaging.pageSize
      }

      if (filter !== null) {
        request['category'] = 'charged'
        request['filter'] = VueApp.$store.state.reservation.reservationFilters[selectedFilter]
      }

      VueApp.$sdk.post('/admin/rsvp', request, r => {
        if (r.error) {
          return
        }
        let results = []
        for (let i = 0; i < r.list.length; i++) {
          let item = r.list[i]
          if (item.type === 'rsvp') {
            results.push(self.formatRsvp(VueApp, r.list[i].data))
            continue
          }
          if (item.type === 'package') {
            results.push(self.formatPackage(VueApp, r.list[i].data))
            continue
          }
        }

        for (let i = 0; i < results.length; i++) {
          if (result.isPackage === results[i].isPackage &&
              result.id === results[i].id) {
            VueApp.$store.commit('dispatch/removeRsvpInTable', result)
            VueApp.$store.commit('dispatch/addRsvpInTable', result)
            break
          }
        }
      })
    })
  },
  formatRsvp (VueApp, item) {
    let driver = null
    if (item.provider.ID !== null) {
      driver = {
        id: item.provider.ID,
        firstName: item.provider.firstName,
        lastName: item.provider.lastName,
        email: item.provider.email,
        phone: item.provider.displayPhone,
        photoUrl: item.provider.avatarUrl
      }
    }
    let flight = null
    let flightName = item.airline
    let flightNumber = item.flightNumber
    let dropoffAirline = ''
    let dropoffFlightNumber = ''
    if (item.airline !== null && item.fligtNumber !== null) {
      flight = item.airline + ' ' + item.flightNumber
    } else if (item.dropoffAirline || item.dropoffFlightNumber) {
      dropoffAirline = item.dropoffAirline
      dropoffFlightNumber = item.dropoffFlightNumber
      flight = item.dropoffAirline + ' ' + item.dropoffFlightNumber
    }

    let guest = null
    if (item.guest.firstName !== null && item.guest.firstName !== '') {
      guest = {
        firstName: item.guest.firstName,
        lastName: item.guest.lastName,
        phone: item.guest.phone
      }
    }

    let statusClass = item.dispatchStatus
    let status = item.dispatchStatus.toUpperCase()
    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch'
      status = 'REQUIRES DISPATCH'
    }

    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch'
      status = 'AUTO DISPATCH'
    }

    if (statusClass === 'complete') {
      status = 'COMPLETED'
    }

    if (statusClass === 'ready') {
      status = 'READY TO GO'
    }

    let serviceType = item.serviceCode.toLowerCase().replace(/(^| )(\w)/g, s => s.toUpperCase())
    if (serviceType === 'Suv') {
      serviceType = 'SUV'
    }

    let phoneNumber = null
    if (item.consumer.phones && item.consumer.phones.length > 0) {
      let phone = item.consumer.phones[0]
      phoneNumber = '+' + phone.countryCode + phone.phoneNumber
    }

    let totalFare = item.payment.fareAmount + item.payment.pickupFee + item.payment.tipAmount + item.travelInsurance
    if (item.airportFee !== null) {
      totalFare = totalFare + item.airportFee
    }

    let pickupTime = moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss')
    // let threshold = VueApp.$store.state.routing.beThereTimeThreshold
    // let maxDuration = Math.floor(item.etaInSec * threshold)
    let maxDuration = Math.floor(item.etaInSec)
    let btt = moment(item.pickupDate, 'YYYY-MM-DD HH:mm:ss').add(maxDuration, 'seconds').subtract(1, 'minute')
    let hoursLeft = btt.diff(pickupTime, 'minutes')
    if (item.complete) {
      hoursLeft = moment(item.complete, 'YYYY-MM-DD hh:mm:ss').diff(pickupTime, 'minutes')
    }
    if (hoursLeft > 60) {
      let hour = Math.floor(hoursLeft/60)
      // if (hour < 10) { hour = '0' + hour }
      let minute = hoursLeft - (hour * 60)
      if (minute < 10) { minute = '0' + minute }
      hoursLeft = `${hour}:${minute} hours`
    } else if (hoursLeft > 0) {
      hoursLeft = `${hoursLeft} minutes`
    }
    if (hoursLeft < 0) {
      hoursLeft = ''
    }

    let rsvpData = {
      brandId: item.brandID,
      isPackage: false,
      airportFee: item.airportFee,
      id: item.ID,
      pickup: {
        address1: item.pickupLocation.addressLine1,
        address2: item.pickupLocation.addressLine2,
        city: item.pickupLocation.city,
        state: item.pickupLocation.state,
        zip: item.pickupLocation.zip,
        lat: item.pickupLocation.lat,
        lng: item.pickupLocation.lng,
        geofenceName: item.pickupLocation.geofenceName,
        geofenceType: item.pickupLocation.geofenceType,
        terminal: item.terminal,
        title: item.pickupLocation.title
      },
      dropoff: {
        address1: item.dropoffLocation.addressLine1,
        address2: item.dropoffLocation.addressLine2,
        city: item.dropoffLocation.city,
        state: item.dropoffLocation.state,
        zip: item.dropoffLocation.zip,
        lat: item.dropoffLocation.lat,
        lng: item.dropoffLocation.lng,
        geofenceName: item.dropoffLocation.geofenceName,
        geofenceType: item.dropoffLocation.geofenceType,
        terminal: item.terminal,
        title: item.dropoffLocation.title
      },
      pickupTime: pickupTime.format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      dropoffTime: item.complete ? moment(item.complete, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)) : btt.format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      hoursLeft: hoursLeft,
      resStatus: item.status,
      status: status,
      statusClass: statusClass,
      rsvpStatus: item.status,
      customer: {
        id: item.consumer.ID,
        firstName: item.consumer.firstName,
        lastName: item.consumer.lastName,
        email: item.consumer.email,
        phone: phoneNumber
      },
      guest: guest,
      driver: driver,
      meetAndGreet: item.pickupType === 'MeetAndGreet',
      airline: flightName,
      airlineCode: item.airlineCode,
      airportCode: item.airportCode,
      flightNumber: flightNumber,
      flight: flight,
      dropoffAirline: dropoffAirline,
      dropoffFlightNumber: dropoffFlightNumber,
      ada: item.ada ? item.ada : null,
      pax: item.passengers,
      luggage: item.luggage === null ? 0 : item.luggage,
      stops: 1,
      serviceType: serviceType,
      serviceId: item.serviceType.id,
      serviceLabel: services.getServiceName(item.serviceCode),
      serviceClass: item.serviceCode,
      distance: item.distance,
      etaInSec: item.etaInSec,
      fare: totalFare,
      driverPayment: {
        base: item.payment.driverPay === null ? 0 : item.payment.driverPay,
        bonus: item.payment.driverBonus === null ? 0 : item.payment.driverBonus,
        tip: item.payment.tipAmount === null ? 0 : item.payment.tipAmount,
        gasFee: item.gasFee || 0,
        pickupFee: item.payment.pickupFee === null ? 0 : item.payment.pickupFee,
        travelInsurance: item.travelInsurance === null ? 0 : item.travelInsurance
      },
      notes: item.notes,
      hasExtraStop: item.hasExtraStop,
      isCharter: item.isCharter,
      isOptinShared: item.optinShared.isOptinShared,
      isMtech: item.isMTech,
      pendingOffer: {
        show: false,
        timer: 0
      },
      totalFare: item.payment.fareAmount ? parseFloat(item.payment.fareAmount.toFixed(2)) : 0
    }
    rsvpData.totalFare += item.airportFee ? parseFloat(item.airportFee.toFixed(2)) : 0
    rsvpData.totalFare += item.gasFee ? parseFloat(item.gasFee.toFixed(2)) : 0
    rsvpData.totalFare += item.portalFee ? parseFloat(item.portalFee.toFixed(2)) : 0
    rsvpData.totalFare += item.travelInsurance ? parseFloat(item.travelInsurance.toFixed(2)) : 0
    rsvpData.totalFare += item.payment.pickupFee ? parseFloat(item.payment.pickupFee.toFixed(2)) : 0
    rsvpData.totalFare += item.payment.tipAmount ? parseFloat(item.payment.tipAmount.toFixed(2)) : 0

    if (!CONFIG.useOldQuatation) {
      rsvpData.serviceType = {
        label: item.serviceType.label,
        color: item.serviceType.color
      }
    }

    return rsvpData
  },
  formatPackage (VueApp, item) {
    let self = this
    let firstRsvp = item.rsvp.filter(rsvp => rsvp.ID === item.stops[0].reservationID)[0]
    let lastRsvp = item.rsvp.filter(rsvp => rsvp.ID === item.stops[item.stops.length - 1].reservationID)[0]

    let statusClass = item.package.packageStatus ? item.package.packageStatus : item.package.status
    let status = item.package.packageStatus ? item.package.packageStatus.toUpperCase() : item.package.status.toUpperCase()

    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch'
      status = 'REQUIRES DISPATCH'
    }

    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch'
      status = 'AUTO DISPATCH'
    }

    if (statusClass === 'cancelled') {
      statusClass = 'canceled'
      status = 'CANCELED'
    }

    if (statusClass === 'ready') {
      status = 'READY TO GO'
    }

    let luggage = 0
    let fare = 0
    let driverPayment = {
      base: 0,
      bonus: item.package.bonusToProvider !== null ? item.package.bonusToProvider : 0,
      tip: 0,
      gasFee: 0,
      pickupFee: 0,
      travelInsurance: 0
    }

    let ada = {
      serviceDog: 0,
      wheelChairLift: 0
    }
    let notes = []
    let reservations = []
    driverPayment.base = item.package.paidForProvider
    let airportFee = 0
    for (let i = 0; i < item.rsvp.length; i++) {
      let rsvp = item.rsvp[i]
      luggage += (rsvp.luggage === null ? 0 : rsvp.luggage)
      fare += rsvp.payment.fareAmount
      fare += rsvp.travelInsurance
      fare += (rsvp.payment.tipAmount === null ? 0 : rsvp.payment.tipAmount)
      fare += (rsvp.gasFee === null ? 0 : rsvp.gasFee)
      // driverPayment.base += (rsvp.payment.driverPay === null ? 0 : rsvp.payment.driverPay)
      driverPayment.tip += (rsvp.payment.tipAmount === null ? 0 : rsvp.payment.tipAmount)
      driverPayment.pickupFee += (rsvp.payment.pickupFee === null ? 0 : rsvp.payment.pickupFee)
      driverPayment.travelInsurance += (rsvp.travelInsurance === null ? 0 : rsvp.travelInsurance)
      driverPayment.gasFee += (rsvp.gasFee === null ? 0 : rsvp.gasFee)

      rsvp.serviceCode = 'shared'
      reservations.push(self.formatRsvp(VueApp, rsvp))

      if (rsvp.airportFee !== null) {
        airportFee += rsvp.airportFee
      }
      if (rsvp.ada.serviceDog === 1) {
        ada.serviceDog = 1
      }
      if (rsvp.ada.wheelChairLift === 1) {
        ada.wheelChairLift = 1
      }

      if(rsvp.notes !== null) {
        notes.push({
          rsvpID: rsvp.ID,
          notes: rsvp.notes
        })
      }
    }

    let route = []
    let legs = []
    for (let i = 0; i < item.stops.length; i++) {
      let rsvp = item.rsvp.filter(rsvp => rsvp.ID === item.stops[i].reservationID)[0]
      let location = rsvp.dropoffLocation
      if (item.stops[i].isPickup) {
        location = rsvp.pickupLocation
      }
      route.push({
        rsvpID: rsvp.ID,
        isPickup: item.stops[i].isPickup,
        address1: location.addressLine1,
        address2: location.addressLine2,
        city: location.city,
        state: location.state,
        zip: location.zip,
        lat: location.lat,
        lng: location.lng,
        geofenceName: location.geofenceName,
        geofenceType: location.geofenceType,
        status: rsvp.dispatchStatus
      })

      let leg = self.formatRsvp(VueApp, rsvp)
      leg.isPickup = item.stops[i].isPickup

      legs.push(leg)
    }

    let driver = null
    if (item.driver != null) {
      driver = {
        id: item.driver.ID,
        firstName: item.driver.firstName,
        lastName: item.driver.lastName,
        email: item.driver.email,
        phone: item.driver.phone,
        photoUrl: item.driver.avatarUrl,
        vehicle: {
          name: `${item.driver.vehicle.manufacturer} ${item.driver.vehicle.model}`,
          photoUrl: item.driver.vehicle.photo,
          licensePlate: item.driver.vehicle.licensePlate
        }
      }
    }

    let airline = firstRsvp.airline
    let airlineCode = firstRsvp.airlineCode
    let flightNumber = firstRsvp.flightNumber
    if (firstRsvp.dropoffAirline) { airline = firstRsvp.dropoffAirline }
    if (firstRsvp.dropoffAirlineCode) { airlineCode = firstRsvp.dropoffAirlineCode }
    if (firstRsvp.dropoffFlightNumber) { flightNumber = firstRsvp.dropoffFlightNumber }
    let flight = !airline || !flightNumber ? null : airline + ' ' + flightNumber
    
    let pickupTime = moment(item.package.localPickupTime)
    let _pickupTime = moment(item.package.localPickupTime)
    // let threshold = VueApp.$store.state.routing.beThereTimeThreshold
    // let maxDuration = Math.floor(lastRsvp.etaInSec * threshold)
    let maxDuration = Math.floor(lastRsvp.etaInSec)
    let brand = CONFIG.brands.find(x => x.id === lastRsvp.brandID)
    if (brand.code === 'fd') {
      // maxDuration = Math.floor(item.package.etaInSec || item.package.maxDuration)
      maxDuration = Math.floor(item.package.maxDuration)
      _pickupTime = moment(firstRsvp.pickupDate)
    }
    let btt = moment(lastRsvp.pickupDate, 'YYYY-MM-DD HH:mm:ss').add(maxDuration, 'seconds').subtract(1, 'minute')
    let hoursLeft = btt.diff(_pickupTime, 'minutes')
    if (lastRsvp.complete) {
      hoursLeft = moment(lastRsvp.complete, 'YYYY-MM-DD hh:mm:ss').diff(_pickupTime, 'minutes')
    }
    if (hoursLeft > 60) {
      let hour = Math.floor(hoursLeft/60)
      // if (hour < 10) { hour = '0' + hour }
      let minute = hoursLeft - (hour * 60)
      if (minute < 10) { minute = '0' + minute }
      hoursLeft = `${hour}:${minute} hours`
    } else if (hoursLeft > 0) {
      hoursLeft = `${hoursLeft} minutes`
    }
    if (hoursLeft < 0) {
      hoursLeft = ''
    }

    let pkgData = {
      isPackage: true,
      airportFee: airportFee,
      id: item.package.id,
      pickup: {
        address1: firstRsvp.pickupLocation.addressLine1,
        address2: firstRsvp.pickupLocation.addressLine2,
        city: firstRsvp.pickupLocation.city,
        state: firstRsvp.pickupLocation.state,
        zip: firstRsvp.pickupLocation.zip,
        lat: firstRsvp.pickupLocation.lat,
        lng: firstRsvp.pickupLocation.lng,
        geofenceName: firstRsvp.pickupLocation.geofenceName,
        geofenceType: firstRsvp.pickupLocation.geofenceType,
        title: firstRsvp.pickupLocation.title
      },
      dropoff: {
        address1: lastRsvp.dropoffLocation.addressLine1,
        address2: lastRsvp.dropoffLocation.addressLine2,
        city: lastRsvp.dropoffLocation.city,
        state: lastRsvp.dropoffLocation.state,
        zip: lastRsvp.dropoffLocation.zip,
        lat: lastRsvp.dropoffLocation.lat,
        lng: lastRsvp.dropoffLocation.lng,
        geofenceName: lastRsvp.dropoffLocation.geofenceName,
        geofenceType: lastRsvp.dropoffLocation.geofenceType,
        title: lastRsvp.dropoffLocation.title
      },
      pickupTime: pickupTime.format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      dropoffTime: lastRsvp.complete ? moment(lastRsvp.complete, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)) : btt.format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      hoursLeft: hoursLeft,
      status: status,
      statusClass: statusClass,
      resStatus: status,
      customer: null,
      guest: null,
      driver: driver,
      meetAndGreet: false,
      airline: airline,
      airlineCode: airlineCode,
      airportCode: firstRsvp.airportCode,
      flightNumber: flightNumber,
      flight: flight,
      ada: ada,
      pax: item.package.pax,
      luggage: luggage,
      rsvps: reservations,
      stops: item.package.stops / 2,
      legs: legs,
      route: route,
      serviceType: 'Shared',
      serviceLabel: services.getServiceName('shared'),
      serviceClass: 'shared',
      serviceId: firstRsvp.serviceType.id,
      fare: fare,
      driverPayment: driverPayment,
      notes: notes,
      // isOptinShared: item.rsvp[0].optinShared.isOptinShared
      pendingOffer: {
        show: false,
        timer: 0
      }
    }

    if (!CONFIG.useOldQuatation) {
      pkgData.serviceType = {
        label: item.rsvp[0].serviceType.label,
        color: item.rsvp[0].serviceType.color
      }
    }

    return pkgData
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/dispatch/reservations.js